module.exports = __webpack_public_path__ + "static/media/ic_categories_shoe.96169efa.svg";